import { render, staticRenderFns } from "./LoginBtn.vue?vue&type=template&id=e5843fd4&scoped=true"
import script from "./LoginBtn.vue?vue&type=script&lang=js"
export * from "./LoginBtn.vue?vue&type=script&lang=js"
import style0 from "./LoginBtn.vue?vue&type=style&index=0&id=e5843fd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5843fd4",
  null
  
)

export default component.exports